module.exports = __webpack_public_path__ + "img/banner@3x.fc99296c.png";